// extracted by mini-css-extract-plugin
export default {"switch":"LanguageSwitch_switch__y639I"};